import mayaPic from "@/public/images/artists/maya.png";
import { Artist } from "@/types/types";

export const maya = {
  id: "175",
  name: "Maya",
  image: mayaPic,
  description: `Maya's voice offers a modern edge—perfect for intros or interludes that call for presence and authenticity. Her sultry tone, balanced with just the right amount of grit, ensures her words resonate, drawing attention without overwhelming the mood.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmaya-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Spoken Word", "Unprocessed"],
      secondary: ["Alluring"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 57,
        high: 73,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
